import React, { lazy, Suspense } from 'react';
import { Router, Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import history from '../helper/history';

import Header from '../components/Header/Header';

import HomePage from '../containers/Home/Home';
import GroupSchedulePage from '../containers/GroupSchedulePage/GroupSchedulePage';
import { Login } from '../components/Login/Login';

import {
    ACTIVATION_PAGE_LINK,
    ADMIN_PAGE_LINK,
    HOME_PAGE_LINK,
    LOGIN_LINK,
    LOGOUT_LINK,
    MY_PROFILE_LINK,
    REGISTRATION_LINK,
    RESET_PASSWORD_LINK,
    SCHEDULE_FOR_LINK,
    SCHEDULE_PAGE_LINK,
    TEACHER_SCHEDULE_LINK,
    SET_PASSWORD_LINK,
    MY_LESSONS_LINK,
} from '../constants/links';
import { userRoles } from '../constants/userRoles';
import { AdminRoute, UserRoute, TeacherRoute, CurriculumEditorRoute } from './routes';

const TeacherSchedule = lazy(() => import('../components/TeacherSchedule/TeacherSchedule'));
const Logout = lazy(() => import('../containers/Auth/Logout'));
const ActivationPage = lazy(() => import('../containers/ActivationPage/ActivationPage'));
const ProfilePage = lazy(() => import('../containers/ProfilePage/ProfilePage'));
const EditCurrentSchedulePage = lazy(() => import('../containers/EditCurrentSchedule/EditCurrentSchedulePage'));
const SetPasswordForm = lazy(() => import('../components/SetPasswordForm/SetPasswordForm'));
const Register = lazy(() => import('../components/Register/Register').then(m => ({ default: m.Register })));
const ResetPassword = lazy(() => import('../components/ResetPassword/ResetPassword').then(m => ({ default: m.ResetPassword })));
const MyLessonsPage = lazy(() => import('../components/MyLessonsPage/MyLessonsPage'));
const AdminRouter = lazy(() => import('./AdminRouter'));


const LoadingFallback = () => (
    <div style={{ padding: '40px', textAlign: 'center' }}>
        Завантаження...
    </div>
);

const Routers = (props) => {
    const { userRole } = props;
    return (
        <Router history={history}>
            <Header userRole={userRole} roles={userRoles} />
            <Suspense fallback={<LoadingFallback />}>
                <Switch>
                    <Route exact path={HOME_PAGE_LINK} component={HomePage} />
                    <TeacherRoute path={SCHEDULE_FOR_LINK} component={GroupSchedulePage} />
                    <Route path={ACTIVATION_PAGE_LINK} component={ActivationPage} />
                    <Route path={SET_PASSWORD_LINK} component={SetPasswordForm} />
                    <Route path={RESET_PASSWORD_LINK} component={ResetPassword} />
                    <Route path={REGISTRATION_LINK} component={Register} />
                    <Route path={LOGIN_LINK} component={Login} />
                    <UserRoute path={TEACHER_SCHEDULE_LINK} component={TeacherSchedule} />
                    <UserRoute path={MY_LESSONS_LINK} component={MyLessonsPage} />
                    <UserRoute path={MY_PROFILE_LINK} component={ProfilePage} />
                    <UserRoute path={LOGOUT_LINK} component={Logout} />
                    <AdminRoute path={SCHEDULE_PAGE_LINK} component={EditCurrentSchedulePage} />
                    {/* Curriculum editors live under /admin too, so the gate here has to admit
                        them; AdminRouter decides which of its pages they actually get. */}
                    <CurriculumEditorRoute path={ADMIN_PAGE_LINK} component={AdminRouter} />
                    <UserRoute path={ACTIVATION_PAGE_LINK}>
                        <Redirect to={HOME_PAGE_LINK} />
                    </UserRoute>
                    <UserRoute path={SCHEDULE_PAGE_LINK}>
                        <Redirect to={LOGIN_LINK} />
                    </UserRoute>
                </Switch>
            </Suspense>
        </Router>
    );
};

const mapStateToProps = (state) => ({ userRole: state.auth.role });

export default connect(mapStateToProps)(Routers);